import { Navigate } from 'react-router-dom';
import useAppUser from 'hooks/useAppUser';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ScreenAndProtectLanding from './landing/ScreenAndProtectLanding';
import { useScreenAndProtectContext } from './ScreenAndProtect';

const ScreenAndProtectIndex = () => {
  const { isEmployeeManager } = useAppUser();
  const { isEnrolled } = useScreenAndProtectContext();
  const { t } = useTranslation();

  if (!isEmployeeManager) {
    return (
      <Alert bsStyle="warning" data-testid="screen-and-protect-no-permission">
        {t('pageScreenAndProtect.noPermission')}
      </Alert>
    );
  }

  if (isEnrolled) {
    return <Navigate to="/screen-and-protect/current" replace />;
  }

  return <ScreenAndProtectLanding />;
};

export default ScreenAndProtectIndex;
